import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { hook } from '@g4/automation-hooks';

const propTypes = {
  /** Tab html `id` attribute */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The `id` attribute of the content region which the activation of this tab makes visible */
  contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  tabRef: PropTypes.object,
  /** Associates a specific action onto an element for the benefit of automated clients consuming it */
  automationHook: PropTypes.string,
  /** The text to display on the tab */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  /** Tells if the tab is active or not */
  active: PropTypes.bool,
  /** Function called on tab selection */
  onClick: PropTypes.func.isRequired,
  /** Function called when the component is mounted */
  onLoad: PropTypes.func,
  /** Styling from styled components */
  className: PropTypes.string,
  /** Tells if the tab is disabled or not */
  disabled: PropTypes.bool,
};

const defaultProps = {
  onLoad: Function.prototype,
  onKeyDown: Function.prototype,
};

const Tab = ({
  tabRef,
  active,
  disabled,
  className,
  automationHook,
  label,
  id,
  contentId,
  onClick,
}) => (
  <div className={className}>
    <TabButton
      id={id}
      ref={tabRef}
      tabIndex={!active ? -1 : undefined}
      role="tab"
      aria-selected={active}
      aria-controls={contentId}
      type="button"
      disabled={disabled}
      onClick={disabled ? Function.prototype : onClick}
      {...hook(automationHook)}
    >
      {typeof label === 'string'
        ? label
        : React.cloneElement(label, {
            active,
            disabled,
          })}
    </TabButton>
  </div>
);

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;

const StyledTab = styled(Tab)`
  display: flex;
  flex: 1;
`;

const TabButton = styled.button`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  flex: 1;
  width: 100%;
  ${props =>
    props.disabled &&
    css`
      cursor: auto;
    `}
`;

export default StyledTab;
